"use strict";

import PageCommon from "../PageCommon";

export default class LicensesTrack extends PageCommon {
    constructor(props) {
        super();
        this.data = {
            id: parseInt(props.id),
            single_licence: true,
            digital: 0,
            media: [],
            format: 0,
            time: 0,
            zone: [],
            exclusive: 0,
            prj_name: "",
            prj_client: "",
        };
        this.price = {
            single_license: 0,
            digital: 0,
            offline: 0,
        };
    }

    set(object) {
        this.data = Object.keys(this.data).map((field) => (this.data[field] = object[field]));
    }

    get() {
        return this.data;
    }

    dispose() {
        this.data = {};
    }
}
